import { render } from "./ParticleField.vue?vue&type=template&id=a7a947fa&scoped=true"
import script from "./ParticleField.vue?vue&type=script&lang=js"
export * from "./ParticleField.vue?vue&type=script&lang=js"

import "./ParticleField.vue?vue&type=style&index=0&id=a7a947fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7a947fa"]])

export default __exports__